// import $ from 'jquery';
import React from 'react';
import PropTypes from 'prop-types';
import ReactLoading from 'react-loading';
// import { omit } from 'lodash';

class InlineFieldGroup extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            hasUndo: this.props.undo || true,
        };
    }
    showUndo() {
        const { isModified } = this.props;
        const { hasUndo } = this.state;

        if (!hasUndo) {
            return false;
        }

        return isModified;
    }
    render() {
        const {
            isModified,
            onUndoClick,
            onSaveClick,
            saveButtonLoading,
        } = this.props;

        return (
            <div
                className={`field-inline-edit field-inline-edit--small form ${
                    isModified ? 'field-inline-edit--active' : ''
                }`}
            >
                <div className='field-inline-edit__area'>
                    <div className='field-inline-edit__item'>
                        {this.props.children}
                    </div>
                    <div className='field-inline-edit__item field-inline-edit__save'>
                        <button
                            type='button'
                            className='button button--field button--less-fat'
                            onClick={(e) => onSaveClick(e)}
                        >
                            {saveButtonLoading ? (
                                <ReactLoading
                                    type='spin'
                                    color='white'
                                    height={20}
                                    width={20}
                                />
                            ) : (
                                <span className='icon icon-save' />
                            )}
                        </button>
                    </div>
                </div>
                {this.showUndo() === true && !saveButtonLoading && (
                    <div className='field-inline-edit__notification'>
                        <button
                            type='button'
                            className='field-inline-edit__notification-text'
                            onClick={(e) => onUndoClick(e)}
                        >
                            Undo <span>edit</span>
                        </button>
                    </div>
                )}
            </div>
        );
    }
}

// default props
InlineFieldGroup.defaultProps = {
    hasUndo: true,
    isModified: false,
    saveButtonLoading: false,
};
// validate props
InlineFieldGroup.propTypes = {
    hasUndo: PropTypes.bool,
    isModified: PropTypes.bool,
    onSaveClick: PropTypes.func.isRequired,
    // onUndoClick: PropTypes.func.isRequired,
    saveButtonLoading: PropTypes.bool,
};

export default InlineFieldGroup;
